import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  users: [], // array of user objects {id, name, ...}
};

const videoCallSlice = createSlice({
  name: "videoCall",
  initialState,
  reducers: {
    addUser: (state, action) => {
      const { roomId, userId } = action.payload;
      const exists = state.users.some(
        (u) => u.roomId === roomId && u.userId === userId
      );
      if (!exists) {
        state.users = [...state.users, { userId, roomId }];
      }
    },
    removeUser: (state, action) => {
      const { roomId, userId } = action.payload;
      state.users = state.users.filter(
        (u) => !(u.roomId === roomId && u.userId === userId)
      );
    },
    clearUsers: (state, action) => {
      const { roomId } = action.payload;
      state.users = state.users.filter((u) => u.roomId !== roomId);
    },
  },
});

export const { addUser, removeUser, clearUsers } = videoCallSlice.actions;
export default videoCallSlice.reducer;
